
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CapGainEstimates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CapGainDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countrycode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languagecode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetclass"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shclcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareclassname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"producttype"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webprdcttaxonomy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cusip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"investmentgroup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainrecorddate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainrecorddatefmt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainpayabledatefmt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainamtlngterm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainamtshrtterm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totaldistamtmth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainreinvstmntamt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estimateflag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prmryshclind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainexdivdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainexdivdatefmt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ltcapgainpctnav"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stcapgainpctnav"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totcapgainpctnav"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"navvalue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"navasofdate"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":648}};
    doc.loc.source = {"body":"query CapGainEstimates($countrycode: String!, $languagecode: String!) {\n  CapGainDistribution(countrycode: $countrycode, languagecode: $languagecode) {\n    assetclass\n    fundid\n    fundname\n    shclcode\n    shareclassname\n    producttype\n    webprdcttaxonomy\n    cusip\n    ticker\n    taid\n    investmentgroup\n    capgainrecorddate\n    capgainrecorddatefmt\n    capgainpayabledatefmt\n    capgainamtlngterm\n    capgainamtshrtterm\n    totaldistamtmth\n    capgainreinvstmntamt\n    estimateflag\n    prmryshclind\n    capgainexdivdate\n    capgainexdivdatefmt\n    ltcapgainpctnav\n    stcapgainpctnav\n    totcapgainpctnav\n    navvalue\n    navasofdate\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CapGainEstimates"] = oneQuery(doc, "CapGainEstimates");
        
